import script from "./BulkDealTable.vue?vue&type=script&setup=true&lang=js"
export * from "./BulkDealTable.vue?vue&type=script&setup=true&lang=js"

import "./BulkDealTable.vue?vue&type=style&index=0&id=61e1aaa6&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61e1aaa6"]])

export default __exports__